import React from 'react';
import s from '../List.module.scss';

const handleDeleteClick = (e, deleteUpload, deliveryId) => {
  e.stopPropagation();
  if (window.confirm("Vill du verkligen radera denna leverans?")) {
    deleteUpload(deliveryId);
  }
}

const handleDeliveryClick = (e, navigate, deliveryId) => {
  e.stopPropagation();
  navigate(`/admin/deliveries/new?id=${deliveryId}`);
}

const Tasks = ({ deleteUpload, navigate, row }) => {
  const deliveryId = row?.original?.deliveryId;
  return (
    <div className={s.tasks}>
      <span 
        onClick={(e) => handleDeliveryClick(e, navigate, deliveryId)} 
        className={s['tasks__action']}
      >
        Leverera
      </span>
      {' | '}
      <span 
        onClick={(e) => handleDeleteClick(e, deleteUpload, deliveryId)} 
        className={s['tasks__action']}
      >
        Radera
      </span> 
    </div>
  );
};

export default Tasks;